var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "my-4", attrs: { "align-v": "start" } },
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex flex-column align-items-center step-circle-container",
              attrs: { cols: "1" },
            },
            [_c("div", { staticClass: "step" }, [_vm._v("2")])]
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "auto" } }, [
            _c("h6", { staticClass: "mb-0 bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("direct-to-lender.participants.receivingBroker")
                  ) +
                  ":\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "ml-5 pl-2" },
        [
          _c("b-col", { attrs: { cols: "3" } }, [
            _c("span", { staticClass: "text-muted text-uppercase" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("account.fullName")) + "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "3" } }, [
            _c("span", { staticClass: "text-muted text-uppercase" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("global.doorr.brokerage")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-col", [
            _c("span", { staticClass: "text-muted text-uppercase" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$tc("global.words.address", 1)) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "ml-5 pl-2" },
        [
          _c(
            "b-col",
            { staticClass: "d-flex align-items-center", attrs: { cols: "3" } },
            [
              _c(
                "profile-avatar",
                _vm._b(
                  {
                    staticClass: "client-avatar mr-2 d-none d-lg-inline",
                    attrs: { "profile-photo": "" },
                  },
                  "profile-avatar",
                  _vm.formatAgentForAvatar(_vm.currentData.agentSelected),
                  false
                )
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.currentData.agentSelected.agentFullName) +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "d-flex align-items-center", attrs: { cols: "3" } },
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.currentData.agentSelected.brokerageName) +
                    " "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "d-flex align-items-center" }, [
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.fullAddress(_vm.currentData.agentSelected.address)
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "my-4", attrs: { "align-v": "start" } },
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex flex-column align-items-center step-circle-container",
              attrs: { cols: "1" },
            },
            [_c("div", { staticClass: "step" }, [_vm._v("3")])]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "11" } },
            [
              _c("h6", { staticClass: "mb-3 bold" }, [
                _vm._v(_vm._s(_vm.$t("global.words.confirmation")) + ":"),
              ]),
              _vm._v(" "),
              _c("checkbox-section", {
                style: _vm.changeBackground,
                attrs: {
                  label: _vm.$t(
                    "direct-to-lender.participants.coBrokerConsent"
                  ),
                  checked: _vm.checked,
                  "container-class": _vm.checked
                    ? "rounded p-3"
                    : "bg-clear-gray rounded p-3",
                },
                on: { change: _vm.handleCheckboxChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }